import React from "react";
import { 
  MetricsCards, 
  PricingPlansOverview, 
  PricingPlanManagement,
  TopAPIUsers, 
  RecentTransactions, 
  RevenueTrends 
} from "./components";

const APIAndBilling = () => {
  
  return (
    <div className="min-h-screen p-3 sm:p-4 md:p-6 space-y-3 sm:space-y-4 md:space-y-6">
   
      {/* Metrics Overview */}
      <div className="mb-4 sm:mb-6">
        <MetricsCards />
      </div>

      {/* Main Content Grid - Responsive Layout */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-3 sm:gap-4 md:gap-6">
        {/* Left Column */}
        <div className="space-y-3 sm:space-y-4 md:space-y-6">
          <PricingPlansOverview />
        </div>

        {/* Right Column */}
        <div className="space-y-3 sm:space-y-4 md:space-y-6">
          <TopAPIUsers />
        </div>
      </div>

      {/* Full Width Tables */}
      <div className="space-y-3 sm:space-y-4 md:space-y-6">
        <RecentTransactions />
        <RevenueTrends />
      </div>

      {/* Pricing Plan Management */}
      <div className="space-y-3 sm:space-y-4 md:space-y-6">
        <PricingPlanManagement />
      </div>
    </div>
  );
};

export default APIAndBilling;
